import { useMutation, useQueryClient } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import {
  createOutreachSettings,
  deleteOutreachSettings,
  updateOutreachSettings,
  CreateOutreachSettingsRequest,
  UpdateOutreachSettingsRequest,
} from "#/services/outreachSettings";

type UpdatePayload = {
  id: string;
  payload: UpdateOutreachSettingsRequest;
};

export function useOutreachSettingsMutations() {
  const queryClient = useQueryClient();

  const createSettings = useMutation({
    mutationFn: (payload: CreateOutreachSettingsRequest) =>
      createOutreachSettings(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: qk.outreachSettingsList() });
    },
  });

  const updateSettings = useMutation({
    mutationFn: ({ id, payload }: UpdatePayload) =>
      updateOutreachSettings(id, payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: qk.outreachSettingsList() });
      if (data?.id) {
        queryClient.invalidateQueries({
          queryKey: qk.outreachSettingsDetail(data.id),
        });
      }
    },
  });

  const removeSettings = useMutation({
    mutationFn: (id: string) => deleteOutreachSettings(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: qk.outreachSettingsList() });
    },
  });

  return { createSettings, updateSettings, removeSettings };
}

export default useOutreachSettingsMutations;
